import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import ExtendableError from 'es6-error';
import stringifyNode from './lib/stringify-node';
export var MigrationError =
/*#__PURE__*/
function (_ExtendableError) {
  _inherits(MigrationError, _ExtendableError);

  function MigrationError() {
    _classCallCheck(this, MigrationError);

    return _possibleConstructorReturn(this, _getPrototypeOf(MigrationError).apply(this, arguments));
  }

  return MigrationError;
}(ExtendableError);
export var ValidationError =
/*#__PURE__*/
function (_ExtendableError2) {
  _inherits(ValidationError, _ExtendableError2);

  function ValidationError(node) {
    var _this;

    _classCallCheck(this, ValidationError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ValidationError).call(this, node));
    _this.message = "node not valid: ".concat(stringifyNode(node)); // eslint-disable-line no-use-before-define

    return _this;
  }

  return ValidationError;
}(ExtendableError);
export var SemverValidationError =
/*#__PURE__*/
function (_ValidationError) {
  _inherits(SemverValidationError, _ValidationError);

  function SemverValidationError(message) {
    var _this2;

    _classCallCheck(this, SemverValidationError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SemverValidationError).call(this, message));
    _this2.message = "Invalid simple semver: ".concat(message); // eslint-disable-line no-use-before-define

    return _this2;
  }

  return SemverValidationError;
}(ValidationError);